import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PMVCommonModule } from './pmv-common.module';
import { ProvideParentFormDirective } from './directives/provide-parent-form.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    PMVCommonModule,
    ScrollPanelModule
  ],
  declarations: [
    ProvideParentFormDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    PMVCommonModule,
    ScrollPanelModule,
    ProvideParentFormDirective,
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts